"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_exports = {};
__export(types_exports, {
  MeetingStatus: () => MeetingStatus,
  RoomAccess: () => RoomAccess,
  RoomType: () => RoomType,
  TranscriptionStatus: () => TranscriptionStatus
});
module.exports = __toCommonJS(types_exports);
var RoomAccess = /* @__PURE__ */ ((RoomAccess2) => {
  RoomAccess2[RoomAccess2["Open"] = 0] = "Open";
  RoomAccess2[RoomAccess2["Knock"] = 1] = "Knock";
  RoomAccess2[RoomAccess2["DND"] = 2] = "DND";
  return RoomAccess2;
})(RoomAccess || {});
var RoomType = /* @__PURE__ */ ((RoomType2) => {
  RoomType2[RoomType2["Video"] = 0] = "Video";
  RoomType2[RoomType2["Audio"] = 1] = "Audio";
  RoomType2[RoomType2["Reception"] = 2] = "Reception";
  return RoomType2;
})(RoomType || {});
var TranscriptionStatus = /* @__PURE__ */ ((TranscriptionStatus2) => {
  TranscriptionStatus2["Idle"] = "idle";
  TranscriptionStatus2["InProgress"] = "inProgress";
  TranscriptionStatus2["Completed"] = "completed";
  return TranscriptionStatus2;
})(TranscriptionStatus || {});
var MeetingStatus = /* @__PURE__ */ ((MeetingStatus2) => {
  MeetingStatus2[MeetingStatus2["Active"] = 0] = "Active";
  MeetingStatus2[MeetingStatus2["Finished"] = 1] = "Finished";
  return MeetingStatus2;
})(MeetingStatus || {});
//# sourceMappingURL=types.js.map
